<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-md-10">
        <div
          class="row justify-content-center text-center"
          :class="{disabled: !store.state.appLoaded}"
        >
          <div class="col-md-12">
            <h3 class="pt-3 pb-3">
              How would you like to fundraise?
            </h3>
          </div>
          <Loader
            v-if="!store.state.appLoaded"
            :show="true"
          />

          <div class="col-md-12 p-0">
            <router-link
              v-show="AuthenticationRouterTeamId"
              :to="{ name: 'charity_individual', params: {} }"
              custom
              v-slot="{ navigate }"
            >
              <div 
                @click="navigate"
                :class="['square_dashboards col-lg-4 col mt-4', (store.state.data_params_pre.teamId != '') ? '' : 'none_params' ]"
              >
                <div
                  class="row d-block mx-lg-3 mx-1 card_box "
                  @click="setPageType('individual')"
                >
                  <div class="card border-0 panel_box_gf gf-driver-button-hollow-no-border p-lg-3">
                    <div class="row ">
                      <div class="col-5 col-lg-12 box_individual py-4 mx-0">
                        <div class="gf_icon_team_db icon_individual" />
                      </div>
                      <div class="col-7 col-lg-12 align-self-center">
                        <div class="card-block">
                          <p class="card-text mobile-title-text">
                            Create an <br>individual page
                          </p>
                        </div>
                      </div>
                    </div>
                  </div><!-- .card -->
                </div><!-- .card_box -->
              </div>
            </router-link>

            <router-link
              v-show="AuthenticationRouterTeamId"
              :to="{ name: 'charity_team', params: {} }"
              custom
              v-slot="{ navigate }"
            >
              <div
                @click="navigate"
                :class="['square_dashboards col-lg-4 col mt-4', (store.state.data_params_pre.teamId != '') ? '' : 'none_params' ]"
              >
                <div
                  class="row d-block mx-lg-3 mx-1 card_box"
                  @click="setPageType('createTeam')"
                >
                  <div class="card border-0 panel_box_gf gf-driver-button-hollow-no-border p-lg-3">
                    <div class="row">
                      <div class="col-5 col-lg-12 box_team py-4 mx-0">
                        <div class="gf_icon_team_db icon_team" />
                      </div>
                      <div class="col-7 col-lg-12 align-self-center">
                        <div class="card-block">
                          <p class="card-text mobile-title-text">
                            Create a <br>team page
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>

            <router-link
              :to="{ name: 'select_team', params: {} }"
              custom
              v-slot="{ navigate }"
            >
              <div 
                @click="navigate"
                :class="['square_dashboards col-lg-4 col mt-4', (store.state.data_params_pre.teamId != '') ? 'm-auto' : 'none_params' ]"
              >
                <div
                  class="row d-block mx-lg-3 mx-1 card_box"
                  @click="setPageType('joinTeam')"
                >
                  <div class="card border-0 panel_box_gf gf-driver-button-hollow-no-border p-lg-3">
                    <div class="row">
                      <div class="col-5 col-lg-12 box_jointeam py-4 mx-0">
                        <div class="gf_icon_team_db icon_jointeam" />
                      </div>
                      <div class="col-7 col-lg-12 align-self-center">
                        <div class="card-block">
                          <p class="card-text mobile-title-text">
                            join an <br>existing team
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div><!-- .col-md-12 -->
          
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import store from './store/store'
import Loader from './components/inc/Loader.vue';
import GfAnalyticsMixin from './components/inc/GfAnalyticsMixin.vue';

export default {
  components: {Loader},
  mixins: [GfAnalyticsMixin],
  computed:{
    AuthenticationRouterTeamId:{
      get: function(){
        if(store.state.data_params_pre.teamId != ''){
          return false
        }
        return true
      }
    }
  },
  data() {
    return {
      store,
    }
  },
  methods: {
    setPageType: function(type) {   
      var createType = this.getCreateType(type);   
      this.analytics({
        'event': 'create_page',
        'createType': createType, 
        'stepNumber':  type == "joinTeam"? '1 of 3' : '1 of 4',
        'stepName': 'select page type'
      });
      this.store.commit("setCreateType", createType);
      this.store.commit('setPageType', type);
    },

    getCreateType(type){
      var createType = '';
      switch (type) {
        case 'joinTeam':
          createType = 'team_member'
          break
        case 'createTeam':
          createType = 'team'
          break
        default:
          createType = type
          break
      }
      return createType;
    }
  }
}
</script>

<style scoped>
@import './assets/css/dashboard.css';
</style>
